import React, { Component } from "react";
import Chart from "react-apexcharts";

export default class CRQTicketCountChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      series: [
        {
          name: "",
          data: [7, 8, 9, 2, 3, 45, 7, 8, 9, 1, 2, 30, 7, 5, 34, 5, 7, 8],
        },
      ],
      options: {
        chart: {
          type: "area",
          events: {
            click: function (chart, w, e) {
              // console.log(chart, w, e)
            },
          },
        },
        xaxis: {
          categories: [
            "September 1,2024",
            "September 2,2024",
            "September 3,2024",
            "September 4,2024",
            "September 5,2024",
            "September 6,2024",
            "September 6,2024",
            "September 7,2024",
            "September 8,2024",
            "September 9,2024",
            "September 10,2024",
            "September 11,2024",
            "September 12,2024",
            "September 13,2024",
            "September 14,2024",
            "September 15,2024",
            "September 16,2024",
            "September 17,2024",
            "September 18,2024",
          ],
          title: {
            text: "Date", // Title for the X-axis
            style: {
              fontSize: "13px",
              fontWeight: "8px",
            },
          },
        },
        yaxis: {
          labels: {
            formatter: function (val) {
              return parseInt(val);
            },
          },
          title: {
            text: "Sum of Count of CRQ No", // Title for the X-axis
            style: {
              fontSize: "13px",
              fontWeight: "8px",
            },
          },
        },
        stroke: {
          curve: "straight",
          width: 3,
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: false,
        },
        plotOptions: {
          bar: {
            columnWidth: "90%",
            distributed: true,
            borderRadius: 5,
          },
        },
      },
    };
  }

  render() {
    return (
      <>
        <Chart
          options={this.state.options}
          series={this.state.series}
          type="area"
          height={300}
        />
      </>
    );
  }
}
